export default __webpack_public_path__ + "static/media/songwriter_benefits_3.0c2d66db.svg";